import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import NoteEditor from './editor.component'
import Typography from '@material-ui/core/Typography';
import { updateFileNotesEditorContent } from '../../../store/actions/session.actions';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class EditorContainer extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.buildEditorState = this.buildEditorState.bind(this);

    this.state = {
      isLoading: true,
    }
  }

  buildEditorState(rawContent) {
      if (rawContent === '') {
        return EditorState.createEmpty();
      }
      return EditorState.createWithContent(convertFromRaw(JSON.parse(rawContent)));
  }

  componentDidMount() {
    this.setState({
      notesEditorState: this.buildEditorState(this.props.editorRawContent),
      isLoading: false,
    });
  }

  handleChange(value) {
    this.setState({
      notesEditorState: value,
    });
    if(this.throttle) {
      clearInterval(this.throttle);
    }
    this.throttle = setTimeout(() => {
      this.props.updateFileNotesEditorContent(
        this.props.session.id,
        this.props.currentFile.id,
        JSON.stringify(convertToRaw(value.getCurrentContent())),
      );
    }, 200);
  }

  render() {
    return (
        <div style={{ padding: '10px 10px 20px' }}>
          <div style={{ padding: '25px 0 0 25px' }}>
            <Typography variant="h4" gutterBottom>Notes</Typography>
          </div>
          {this.state.isLoading ? '' :
          <NoteEditor
          handleChange={this.handleChange}
          editorState={this.state.notesEditorState}
          />
          }
        </div>
    );
  }
}

EditorContainer.propTypes = {
  currentFile: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  editorState: PropTypes.object,
  editorRawContent: PropTypes.string.isRequired,
  updateFileNotesEditorContent: PropTypes.func.isRequired,
};

export default withRouter(connect(
null,
  { updateFileNotesEditorContent },
)(EditorContainer));
